import { serializeToUrlParams } from "@/hooks/filter-params/serialization"

import { RUNS_VIEW_MODE_URL_PARAM } from "../hooks/useRunsViewModeState"
import type { FilterState } from "../types/filterState"
import { RUNS_VIEW_MODE } from "../types/viewMode"
import {
  DEFAULT_RUNS_FILTER_STATE,
  RUNS_FILTER_PARAM_SCHEMA,
} from "./filterStateConfig"

const SORT_URL_KEY = "sort"

/**
 * Path to the simulated conversations list (the runs page in its simulations
 * view) with the given filters applied, in the URL format the page reads.
 */
export function buildSimulatedConversationsListPath(
  filters: Partial<Omit<FilterState, "sortDescriptor">>,
): string {
  const params = new URLSearchParams(
    serializeToUrlParams(
      { ...DEFAULT_RUNS_FILTER_STATE, ...filters },
      RUNS_FILTER_PARAM_SCHEMA,
    ),
  )
  params.delete(SORT_URL_KEY)
  params.set(RUNS_VIEW_MODE_URL_PARAM, RUNS_VIEW_MODE.SIMULATIONS)

  return `/simulated?${params.toString()}`
}
